import { Component, OnInit } from '@angular/core';

import { FileVm } from '../../../../shared/Models/fileVm';
import { Router } from '@angular/router';
import { uploadService } from './../../../../shared/uploadService';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { OpenDataService } from '../../services/open-data.service';
import { switchMap } from 'rxjs/operators';
import { OpenData } from '../../Models/open-data';


@Component({
  selector: 'add-open-data',
  templateUrl: './add-open-data.component.html',
  styleUrls: ['./add-open-data.component.scss']
})
export class AddOpenDataComponent implements OnInit {
  isLoading: boolean = false;
  model = {} as OpenData;
  isEdit = false;
   validPhoto: boolean = true;
  previosusAttachments: FileVm[] = [];
  formData = new FormData();
  attachements: FormData;
  newPhotoUploaded = false;
  constructor( private diagRef: NbDialogRef<AddOpenDataComponent>,
      private service: OpenDataService,
      private uploadService: uploadService,
      private toast: NbToastrService,
      private route : Router) { }

 ngOnInit() {
    this.route.events.subscribe(() => {
      this.diagRef.close('false');
    });

    if (this.isEdit) {
      this.uploadService.updateFiles({ files: [], previousAttachments: this.model.attachements });
    } else {
        this.model.keyAR = '';
      this.model.keyEN = '';
      this.model.titleAR = '';
      this.model.titleEN = '';
      this.model.descriptionAR = '';
      this.model.descriptionEN = '';
      this.model.description2AR = '';
      this.model.description2EN = '';
      this.attachements = new FormData();
      this.uploadService.updateFiles({ files: [], previousAttachments: [] });
    }
  }


  updateOpenData() {
    this.isLoading = true;
    const attachments$ = this.uploadService.uploadMultipleFiles();

    attachments$
      .pipe(
        switchMap((files) => {
          this.model.attachements = files;
          return this.service.put(this.model.id, this.model);
        })
      )
      .subscribe(
        () => {
          this.isLoading = false;
          this.diagRef.close('true');
          this.toast.show('تم تعديل السجل بنجاح', '', { status: 'success', duration: 3000 });
        },
        () => {
          this.isLoading = false;
          this.toast.show('حدث خطأ أثناء التعديل', '', { status: 'danger', duration: 3000 });
        }
      );
  }
   save() {
    this.isLoading = true;

    const attachments$ = this.uploadService.uploadMultipleFiles();
    attachments$
      .pipe(
        switchMap((files) => {
          this.model.attachements = files;
          return this.service.post(this.model);
        })
      )
      .subscribe(
        () => {
          this.isLoading = false;
          this.diagRef.close('true');
          this.toast.show('تمت الإضافة بنجاح', '', { status: 'success', duration: 3000 });
        },
        () => {
          this.isLoading = false;
          this.toast.show('حدث خطأ أثناء الإضافة', '', { status: 'danger', duration: 3000 });
        }
      );
  }
    getFormData(event) {
    this.formData = new FormData();
    this.formData = event;
    if (event) this.validPhoto = true;
    this.newPhotoUploaded = true;
  }

  uploadFile(event) {
    this.uploadService.updateFiles({ files: event, previousAttachments: this.model.attachements });
  }


  close() {
    this.diagRef.close();
  }
}


